<script setup lang="ts">
import { useAppEnv } from '~/composables/layout/useAppEnv'

const { showRecetteBadge } = useAppEnv()
</script>

<template>
  <h6 class="website-name__beta">
    BETA<sup
      v-if="showRecetteBadge"
      class="website-name__recette"
    >recette</sup>
  </h6>
</template>

<style scoped lang="scss">
@use '~/assets/scss/partials/elpdl/spacing' as *;

.website-name__beta {
  margin: 0;
  color: var(--color-beta-badge);
}

.website-name__recette {
  margin: 0 0 0 $spacing-3xs;
  font-size: 0.75rem;
  line-height: 1;
  font-weight: 600;
  vertical-align: super;
}
</style>
